import VueSession from 'vue-session'
export default function (Vue) {
    // let authenticatedUser;

    Vue.use(VueSession);
Vue.auth = {
  //set tokens
  //destroy tokens


  isAuthenticated ()  {
    if(this.$session.has('jwt')){
        return true;
    } else {
      return false;
    }
  }
};

Object.defineProperties(Vue.prototype, {
  $auth: {
    get: () => {
      return Vue.auth;
    }
  }
});
}